module.exports = __webpack_public_path__ + "static/media/reservation.4b0969d8.svg";